export enum TimeZoneOffset {
    UTC= 0,
    GMT= 0,
    ECT= 1,    // European Central Time
    EET= 2,    // Eastern European Time
    ART= 2,    // Egypt Standard Time
    EAT= 3,    // Eastern African Time
    MET= 3.5,  // Middle East Time
    NET= 4,    // Near East Time
    PLT= 5,    // Pakistan Lahore Time
    IST= 5.5,  // India Standard Time
    BST= 6,    // Bangladesh Standard Time
    VST= 7,    // Vietnam Standard Time
    CTT= 8,    // China Taiwan Time
    JST= 9,    // Japan Standard Time
    ACT= 9.5,  // Australia Central Time
    AET= 10,   // Australia Eastern Time
    SST= 11,   // Solomon Standard Time
    NST= 12,   // New Zealand Standard Time
    MIT= -11,  // Midway Islands Time
    HST= -10,  // Hawaii Standard Time
    AST= -9,   // Alaska Standard Time
    PST= -8,   // Pacific Standard Time
    PNT= -7,   // Phoenix Standard Time
    MST= -7,   // Mountain Standard Time
    CST= -6,   // Central Standard Time
    EST= -5,   // Eastern Standard Time
    IET= -5,   // Indiana Eastern Standard Time
    PRT= -4,   // Puerto Rico and US Virgin Islands Time
    CNT= -3.5, // Canada Newfoundland Time
    AGT= -3,   // Argentina Standard Time
    BET= -3,   // Brazil Eastern Time
    CAT= -1    // Central African Time
}